import { colors } from '@nerdwallet/base-styles/variables';

import amortizationRelatedArticles from './amortization-related-articles';

export const DATA_KEYS = ['remaining', 'principal', 'interest'];
export const COLOR_PATTERN = [colors.blue, colors.green, colors.yellow];
export const THROTTLE_INTERVAL = 100;
export const MOBILE_BREAKDOWN = 743;

export const YEAR_TRACKING = {
  formName: 'mc_amortization',
  fieldName: 'year_release',
};

export const RELATED_ARTICLES = {
  entityName: 'mortgages_amortization_related_articles',
  sectionName: 'mortgages_amortization_related_articles',
  sectionPosition: 6,
  articles: amortizationRelatedArticles,
};
